const Bnbsc = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16 0C24.8372 0 32 7.16282 32 16C32 24.8372 24.8372 32 16 32C7.16282 32 0 24.8372 0 16C0 7.16282 7.16282 0 16 0Z'
				fill='black'
			/>
			<path
				d='M16 0.5C24.561 0.5 31.5 7.43896 31.5 16C31.5 24.561 24.561 31.5 16 31.5C7.43896 31.5 0.5 24.561 0.5 16C0.5 7.43896 7.43896 0.5 16 0.5Z'
				stroke='white'
				strokeOpacity='0.2'
			/>
			<path
				d='M8.7936 15.9999L8.80514 20.2307L12.4 22.3461V24.823L6.70129 21.4807V14.7627L8.7936 15.9999ZM8.7936 11.7692V14.2345L6.70001 12.9961V10.5307L8.7936 9.29224L10.8974 10.5307L8.7936 11.7692ZM13.9013 10.5307L15.9949 9.29224L18.0987 10.5307L15.9949 11.7692L13.9013 10.5307Z'
				fill='#F0B90B'
			/>
			<path
				d='M10.3064 19.3538V16.8769L12.4 18.1153V20.5807L10.3064 19.3538ZM13.9013 23.2333L15.9949 24.4717L18.0987 23.2333V25.6986L15.9949 26.9371L13.9013 25.6986V23.2333ZM21.1013 10.5307L23.1949 9.29224L25.2987 10.5307V12.9961L23.1949 14.2345V11.7692L21.1013 10.5307ZM23.1949 20.2307L23.2064 15.9999L25.3 14.7615V21.4794L19.6013 24.8217V22.3448L23.1949 20.2307Z'
				fill='#F0B90B'
			/>
			<path d='M21.6936 19.3539L19.6 20.5808V18.1154L21.6936 16.877V19.3539Z' fill='#F0B90B' />
			<path
				d='M21.6936 12.6461L21.7051 15.123L18.1 17.2384V21.4794L16.0064 22.7063L13.9128 21.4794V17.2384L10.3077 15.123V12.6461L12.4102 11.4076L15.9936 13.5333L19.5987 11.4076L21.7026 12.6461H21.6936ZM10.3064 8.41659L15.9949 5.06274L21.6936 8.41659L19.6 9.65505L15.9949 7.52941L12.4 9.65505L10.3064 8.41659Z'
				fill='#F0B90B'
			/>
		</svg>
	);
};

export default Bnbsc;
